import {
  any,
  async,
  fromJSX,
  nothing,
  Updater,
  Widget
} from 'widgets-for-react'
import { LoadCssReponse, LoadScriptReponse } from '../../utils/scripts'
import { JqueryState, jqueryStateUpdaters } from './jqueryState'

export const jqueryWidget = (
  state: JqueryState
): Widget<Updater<JqueryState>> =>
  any<Updater<JqueryState>>([
    async<LoadCssReponse<'jq'>>(state.jquery, () => nothing(), {
      key: 'jq'
    }).map(jqueryStateUpdaters.updateJquery),
    state.jquery.kind === 'loaded'
      ? any<Updater<JqueryState>>([
          async<LoadScriptReponse<'jqa'>>(
            state.jqueryValidate,
            () => nothing(),
            { key: 'jqa' }
          ).map(jqueryStateUpdaters.updateJqueryValidate),
          async<LoadScriptReponse<'jqui'>>(state.jqueryUi, () => nothing(), {
            key: 'jqui'
          }).map(jqueryStateUpdaters.updateJqueryUi),
          async<LoadCssReponse<'jquicss'>>(state.jqueryUiCss, () => nothing(), {
            key: 'jquicss'
          }).map(jqueryStateUpdaters.updateJqueryUiCss)
        ])
      : nothing()
  ])
